<template>
  <div class="projectileFrame comWidth">
    <div>
      <div class="scu">登錄成功</div>
      <el-row>
        <el-button type="primary" @click="continueShopping">繼續購物</el-button>
        <el-button type="info" @click="returnOne">返回上一頁</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ProjectileFrame',
    data () {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    },
    methods:{
      /*返回上一页*/
      returnOne(){
        var hrefW = (window.location.href).split('#')[1];
        if(hrefW == '/signIn' || hrefW == '/signUp'){
          this.$router.push({
            name:'HomePage'
          })
        }else {
          this.$router.go(-1)
        }

      },

      /*继续购物*/
      continueShopping(){
        this.$router.push({
          name:'ProductPage'
        })
      }
    },
    created(){
      window.scrollTo(0,0)
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .projectileFrame{
    text-align: center;
    margin-top: 100px;
    font-size:16px;

  &>div{
      width: 100%;
  .scu{
    color: #949090;
    font-size: 20px;
    height: 100px;
    line-height: 100px;
    background: #00000014;
    margin-bottom: 40px;
  }
  }
  }
</style>



// WEBPACK FOOTER //
// src/components/ProjectileFrame.vue